export default class UrlParser {
  public static readonly getTenantId = () => {
    return UrlParser.getUrlParam('tenantId') ?? '';
  };

  public static readonly getQuoteShortCode = () => {
    return UrlParser.getUrlParam('quote') ?? '';
  };

  private static getUrlParam = (param: string) => {
    return new URLSearchParams(window.location.search).get(param);
  };

  public static readonly getUrlPath = () => {
    return window.location.pathname.toLowerCase();
  }
}
